import { loadMemoryCatalog } from './memory/memoryCatalog';
import { buildMemoryBoards } from './memory/memoryDeck';
import { loadReflexCatalog, REFLEX_VISUAL_ASSETS } from './reflex/reflexCatalog';
import { preloadTournamentImages } from './tournamentLocalMatch';

export async function prepareMiniTaskRoundAssets(round) {
  let extraUrls = [];
  if (round.task_type === 'memory_matching') {
    const catalog = await loadMemoryCatalog(round.catalog_version);
    const decks = buildMemoryBoards(
      catalog.assets,
      round.deck_pair_counts || Number(round.pair_count),
      round.deck_seeds,
    );
    extraUrls = decks.flat().map((card) => card.src);
  } else if (round.task_type === 'reflex_catch') {
    await loadReflexCatalog(round.asset_catalog_version);
    extraUrls = Object.values(REFLEX_VISUAL_ASSETS);
  }
  return preloadTournamentImages({ round, assets: extraUrls.map((url) => ({ url })) });
}

export function releaseMiniTaskRoundAssets(assetUrls) {
  Object.values(assetUrls || {}).forEach((url) => {
    if (url.startsWith('blob:')) window.URL.revokeObjectURL(url);
  });
}
